import { create } from 'zustand';

export const useLeadCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null, //
  openLeadCreate: (payload,callback=null) => set({ isOpen: true, payload,callback }),
  close: (result) => set((state) => {
    // Call callback if exists, and clear everything
    if (state.callback) state.callback(result);
    return { isOpen: false, payload: {}, callback: null };
  }),
}));
export const openLeadCreate = (payload) => {
  const store = useLeadCreateStore.getState();
  store.openLeadCreate(payload);
};

export const closeLeadCreate = () => {
  const store = useLeadCreateStore.getState();
  store.close();
};